import type { WebappMission } from '@/types/types'
import { isValidHttpUrl } from './brandAppUrl'

export const missionKey = (mission: WebappMission, index: number) =>
  mission.type ?? (mission.id === null || mission.id === undefined ? `custom-new-${index}` : `custom-${mission.id}`)

export const canShowMission = (mission: WebappMission, renderedTitle: string): boolean => {
  if (!renderedTitle.trim()) return false
  if (mission.type === null) return isValidHttpUrl((mission.destinationUrl ?? '').trim())
  if (mission.type === 'contest_game') return Boolean(mission.instanceId)

  return true
}

export const isWalletMissionLocked = (mission: Pick<WebappMission, 'type'>, hasWallet: boolean): boolean =>
  mission.type === 'wallet' && !hasWallet

export const isMissionShown = (mission: Pick<WebappMission, 'type' | 'isVisible'>, hasWallet: boolean): boolean =>
  mission.isVisible && !isWalletMissionLocked(mission, hasWallet)
